export function formatPassengers(passengers: number, isChild: boolean) {
    if (!isChild) {
        return passengers > 1 ? `${passengers} adults` : `${passengers} adult`;
    }
    return passengers > 1 ? `${passengers} children` : `${passengers} child`;
}
